import { VueNodeViewRenderer } from '@tiptap/vue-2';
import { Node, mergeAttributes } from '@tiptap/core';
import TextParserChip from '@/components/DataInput/DataInputMenu/MenuLists/TextParserChip';
import { TEXT_PARSER_HTML_TAG } from '../DataChip/data-chip.const';

export default Node.create({
	group: 'inline',
	name: 'text-parser-chip-extension',

	atom: true,
	inline: true,
	selectable: false,
	defining: true, //If a node should be kept for such replace operations (e.g. copy paste)

	addAttributes() {
		return {
			content: { default: { content: '' } },
		};
	},
	parseHTML() {
		return [{ tag: TEXT_PARSER_HTML_TAG }];
	},

	renderHTML({ HTMLAttributes }) {
		return [TEXT_PARSER_HTML_TAG, mergeAttributes(HTMLAttributes)];
	},

	// Used to convert an atom node to plain text
	renderText({ value }) {
		return `@${value}`;
	},

	addNodeView() {
		return VueNodeViewRenderer(TextParserChip);
	},
});
